import HOST_API from 'constants/HOST_API';
import useFetch from './useFetch';


import React from 'react';
import Recoil from 'recoil';
import CryptoJS from 'crypto-js';

export default function useReportAbnormalBloodSugar(props) {
  const onRequest = useFetch(HOST_API, 'V100/report/abnormal-blood-sugar');

  const requestReportAbnormalBloodSugar = React.useCallback((parameters, callback) => {
    const {
      patient_no,
      search_start_time,
      search_end_time,
      abnormal_bld_sugr_tp_cd,
      bld_sugr_at_search,
      page_row_cnt,
      page_no,
      sort_list,
    } = parameters;

    if(!patient_no) return;

    const onReceive = (res) => {
      if (+res.res_code === 200) {
        callback && callback(true, res.data, parameters);
      } else {
        callback && callback(false, { message: res?.res_msg });
      }
    };
    const onCatch = (err) => {
      callback && callback(false, { messgae: '서버에 연결할 수 없습니다.' }, parameters);
    };
    const onExpire = (abort) => {
      abort('Timeout');
      callback && callback(false, { message: '서버가 응답하지 않습니다.' }, parameters);
      return true;
    };

    onRequest({
      parameters: {
        patient_no,
        search_start_time,
        search_end_time,
        abnormal_bld_sugr_tp_cd,
        bld_sugr_at_search,
        page_row_cnt,
        page_no,
        sort_list,
      },
      timeout: 6000,
      events: {
        onReceive,
        onExpire,
        onCatch,
      }
    });
  }, [onRequest]);

  const onReportAbnormalBloodSugar = React.useCallback((callback) => (parameters) => {
    requestReportAbnormalBloodSugar(parameters, callback);
  }, [requestReportAbnormalBloodSugar]);

  return {
    requestReportAbnormalBloodSugar,
    onReportAbnormalBloodSugar,
  };
}
